import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  GetDropDownList,
  getEmployeeAvailableLeaveBalance,
  getEmployeeReportingManager,
  getLeaveRequestDataById,
  getPendingLeavesById,
  getWorkPolicyHolidayList,
  getWorkPolicyWorkdayList,
  InsertUpdateLeaveRequestData,
  getWorkPolicySaturdayList,
  //sai Changes
  EmployeeAvailableLeaveBalance,
  getLeaveConfigData,
  getLastAppliedLeave,
  GetEmployeeLeavesData,
  getUnplannedLeaveStatus,
  getLongLeaveDiffStatus,
  getHolidayFromPolicyHoliday,
} from "../../../Helpers/API/APIEndPoints";
import InputForm from "../../../Components/InputForm/InputForm";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import moment from "moment";
import Heading from "../../../Components/Heading/Heading";
import { leaveTypeOptions } from "../../../Common/CommonJson";
import notify from "../../../Helpers/ToastNotification";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import { Form } from "react-bootstrap";
import { data } from "autoprefixer";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { Console } from "console";


interface FilterObject {
  approver: string | null;
  requestor: string | null;
  fromDate: string | null;
  toDate: string | null;
  requestStatus: string | null;
}

interface FilterValues {
  filterObj: FilterObject;
}

interface LocationState {
  id: number;
  role: string;
  leaveType: number;
  requestStatus: number;
  requestorId: number;
  filterValues: FilterValues;
}

const LeaveRequestMasterEdit = () => {
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const location = useLocation();
 // console.log('curretn in edit',location.pathname)
  const currentDate = new Date();
  const state = location.state as LocationState; // Type Casting, then you can get the params passed via router
 // console.log('location STATE',state)
  const [leaveDays, setLeaveDays] = useState(0);
  const [remark, setRemark] = useState("");
  const [submitId, setSubmitId] = useState(0);
  const [approverOptions, setApproverOptions] = useState<any>([]);
  const [leaveReasonOptions, setLeaveReasonOptions] = useState<any>([]);
  const [approver, setApprover] = useState<any>({});
  const approverId = useRef<any>(0);
  const requestorId = useRef<any>(0);
  const [leaveType, setLeaveType] = useState<any>({});
  const [leaveReason, setLeaveReason] = useState<any>({});
  const [fromDate, setFromDate] = React.useState<Date | null>(new Date());
  const [toDate, setToDate] = React.useState<Date | null>(new Date());
  const [formErrors, setFormErrors] = useState({});
  const [leaveBalance, setLeaveBalance] = useState(0);
  const [fromDateLeaveType, setFromDateLeaveType] = useState<any>(
    leaveTypeOptions[0]
  );
  const [toDateLeaveType, setToDateLeaveType] = useState<any>(
    leaveTypeOptions[0]
  );
  const [holidayList, setHolidayList] = useState([]);
  const [workdayList, setWorkdayList] = useState([]);
  const [leaveTypeOptionsArr, setLeaveTypeOptionsArr] = useState<any>([]);
  const [FYIUsers, setFYIUsers] = useState<any>([]);
  const FYIUsersId = useRef<any>();
  const [leaveStatusOnEdit, setLeaveStatusOnEdit] = useState(false);
  let formErrorObj = {};

  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );
  const { EmployeeId, EmployeeWorkPolicyId, RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const [canChangeRequestor, setCanChangeRequestor] = useState(false);
  const [requestor, setRequestor] = useState<any>({
    value: Number(EmployeeId),
  });

  //sangam 10-may-2024
  const [currentrequestor, setCurrentRequestor] = useState<any>({
    value: Number(EmployeeId),
  });
  const [fyiString,setFyiString]= useState<any>("");
  const [pendingDates, setPendingDates] = useState<any>([]);
  const [lastApplied, setLastApplied] = React.useState<Date | null>(new Date());
  const [lastLeaveDays, setLastLeaveDays] = useState(0);
  const [isPlanned, setIsPlanned] = useState(false);
  const [isLong, setIsLong] = useState(false);
  const [employeeLeaveData, setEmployeeLeaveData] = useState([]);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [configObj, setConfigObj] = useState<any>({
    MaxLeaveCount: null,
    LongLeaveDiff: null,
    ShortLeaveCond: null,
    LongLeaveCond: null,
    ShortLeaveMin: null,
    ShortLeaveMax: null,
    LongLeaveMin: null,
    LongLeaveMax: null,
  });

  const [reason, setReason] = useState(""); //   sangam
  const [unplannedLeaveStatus, setUnplannedLeaveStatus] = useState(false);
  const [leavestatusId, setLeaveStatusId] = useState<any>()

  const [isPlan, setIsPlan] = useState<any>();

  const [isLongLeaveAllowed, setIsLongLeaveAllowed] = useState(false);

  const [policyHolidays, setpolicyHolidays] = useState([]);

  useEffect(() => {
    //sangam
    if (!leaveStatusOnEdit) {
      setReason("");
    }
  }, [leaveStatusOnEdit]);

  useEffect(() => {
   // debugger;
    getLeavesDashabordData();
  }, [start, searchText, sortDirection, sortColumn, currentrequestor.value]);

  useEffect(() => {
    if (
      RoleIdArray.includes("3") ||
      RoleIdArray.includes("8") || //added by mahesh 9/9/2024
      RoleIdArray.includes("4")
      //|| RoleIdArray.includes("2")
    ) {
      setCanChangeRequestor(true);
    }
  }, [RoleIdArray]);

  useEffect(() => {
    requestorId.current = requestor.value;
    (async () => {
      await getApprover();
      //  await getEmployeeLeave();
      setPendingDates([]);
      await leaveTypeApiCall();
      await getPendingLeaves();
      await getWorkdayList();
      await getHolidayList();
      await getPolicyHolidayList();
      //await LastAppliedLeave();
      //sangam 10-may-2024
      setCurrentRequestor(requestor);
    })();
  }, [requestor.value]);

  useEffect(() => {
    (async () => {
      //console.log('request status=>',leaveStatusOnEdit)
      
      await approverApiCall();
      await leaveReasonApiCall();
     // await getLeaveReqById();
      // await configObjApiCall();
    })();
  }, []);

  useEffect(()=>{
      if(location.state){
     getLeaveReqById();
      }
  },[location.state])

  useEffect(() => {
    leaveTypeApiCall();
    getEmployeeLeave();
    GetUnplannedLeaveStatus();
    GetLongLeaveDiffStatus();
    //sangam 10-may-2024
    setCurrentRequestor(requestor);
  }, [requestor.value]);

  useEffect(() => {
    getEmployeeLeave();  
  }, [leaveType]);

  useEffect(()=>
  {
    GetUnplannedLeaveStatus();
    GetLongLeaveDiffStatus();
  }, [fromDate,leaveType])

  const GetUnplannedLeaveStatus = async () =>{
    //debugger;
    let postobject;
    
    postobject = {
      requestorId : requestor.value,
      fromDate : moment(fromDate).format(moment.HTML5_FMT.DATE),
      leaveType : leaveType.value
    }

    const {data} = await APICall(getUnplannedLeaveStatus, "POST", postobject);

    if(data != null && data !== undefined)
    {
      //console.log("Hello Buddy=>",data.unplannedLeaveStatus)
        setUnplannedLeaveStatus(data.unplannedLeaveStatus);
    }
  }

  const GetLongLeaveDiffStatus = async () => {
    let requestParams = {
      requestorId : requestor.value,
      fromDate : moment(fromDate).format(moment.HTML5_FMT.DATE)
    }

    const {data} = await APICall(getLongLeaveDiffStatus, "POST", requestParams);

    if(data != null && data !== undefined)
    {
        setIsLongLeaveAllowed(data.isLongLeaveAllowed);
    }
  }


  useEffect(() => {

    if (approverId.current !== 0) {
      let approver = approverOptions.find(
        (ele) => ele.value === approverId.current
      );
      setApprover(approver);
    }
  }, [approverId.current, approverOptions]);

  const submitApiCall = async (submitObj: any) => {
  // console.log('obj==>',submitObj)

    if(submitObj.LeaveDays > 3 && submitObj.leaveType === 1 && submitObj.IsPlanned === false ) {
      notify(1, 'You are not allowed to take more than 3 unplanned leaves');
    }else{
        showLoader();

        const { data, status } = await APICall(
          InsertUpdateLeaveRequestData,
          "POST",
          submitObj
        );
    
        hideLoader();
    
        if (data && data > 0 && status === 0) {
          navigate(`${env}/master/leaveRequest`);
          //change notification as per screen
          if (state !== null && state.role === "self") {
            notify(0, "Leave Cancelled!");
          } else if (
            state !== null &&
            state.role === "manager" &&
            leaveStatusOnEdit === true
          ) {
            notify(0, "Leave Cancelled!");
          } else if (
            state !== null &&
            state.role !== "self" &&
            leaveStatusOnEdit === true
          ) {
            notify(0, "Leave Approved!");
          } else if (
            state !== null &&
            state.role !== "self" &&
            leaveStatusOnEdit === false
          ) {
            notify(0, "Leave Rejected!");
          } 
        else {
            notify(0, "Leave Requested successfully");
          }
          
        } 
        else if (
          state != null &&
          state.role === "self" &&
          data === 0 &&
          status === 0
        ) {
          notify(1, "Leave cannot be cancelled  for backdated date ");
        }
      else {
          notify(1, "Leave Request failed");
          // notify(1, "Leave cannot be cancelled  for backdated date ");
        }
    }


  };

  const getLeaveReqById = async () => {
    if (state && state.id !== null) {
      let post = {
        id: state.id,
      };
      const { data } = await APICall(getLeaveRequestDataById, "POST", post);

      //console.log('data on edit ==>', data)

      if (data !== null || typeof data !== "string") {
        if (data.length > 0) {
          setSubmitId(data[0].id);

          // setApprover({ value: data[0].approverId, label: data[0].approver });
          approverId.current = data[0].approverId;
          requestorId.current = data[0].requestorId;

          setRequestor({value : data[0]?.requestorId
            , label: data[0].requestor
          })

          setLeaveStatusOnEdit(
            data[0].requestStatus === 3
              ? false
              : state.role === "self"
              ? false
              : state.role === "manager"
              ? false
              : true
          );
          setLeaveStatusId(data[0].requestStatus)
          setFromDate(new Date(data[0].fromDate));
          setToDate(new Date(data[0].toDate));
          // setLeaveDays(data[0].leaveDays.toString());
          setLeaveReason({ value: data[0].resonId, label: data[0].reson });
          setRemark(data[0].remark === null ? "" : data[0].remark);
          // setIsActive(data.isActive);
          leaveTypeOptions.map((option: any) => {
            if (option.value === data[0].fromDateLeaveType) {
              setFromDateLeaveType(option);
            }
          });
          leaveTypeOptions.map((option: any) => {
            if (option.value === data[0].toDateLeaveType) {
              setToDateLeaveType(option);
            }
          });
          FYIUsersId.current =
            data[0].fyiUsers !== null &&
            data[0].fyiUsers.split(`,`).map((x) => parseInt(x, 10));

          setFyiString(data[0].fyiUsers);
          setIsPlanned(data[0].isplanned);
          setIsPlan(data[0].isplanned);
        }
      }
    }
  };
  useEffect(()=>{

    if(location.state){
      // console.log('fyi string==>',fyiString)
      //  console.log('isplanned ==>',isPlanned)
      //console.log('isplan ==>',isPlan)

      const idsArray = fyiString?.split(',').map(id => id.trim());
      //  console.log('idarra==>',idsArray)
      const matchObj = approverOptions?.filter((ele) => {
        return idsArray.includes(ele.value.toString().trim());  
      });
      setFYIUsers(matchObj)
      //console.log("Isplanned1")
      setIsPlanned(isPlan)
    }

  },[location.state,approverOptions,isPlan])

  const resetFunc = () => {
    setFormErrors({});
    setFromDate(null);
    setToDate(null);
    setLeaveDays(0);
    setLeaveReason({});
    setRemark("");
    setReason("");
    setFYIUsers([]);
  };

  const approverApiCall = async () => {
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let approverArray = [];
      await data.map((approver: any) => {
        let tempObj = {
          eid: approver.eid,
          value: approver.id,
          label: approver.name,
          workPolicyID: approver.workPolicyId,
        };
        approverArray.push(tempObj);
      });

      setApproverOptions(approverArray);

      if (requestorId.current !== 0) {
        let requestor = approverArray.find(
          (ele) => ele.value === requestorId.current
        );
        setRequestor(requestor);
      }

      if (FYIUsersId.current !== undefined && FYIUsersId.current.length > 0) {
        let FYIUsersArr = [];
        FYIUsersId.current.forEach((element) => {
          let bindData = approverArray.find((ele) => ele.value === element);
          FYIUsersArr.push(bindData);
        });
        setFYIUsers(FYIUsersArr);
      }
    }
  };

  const leaveReasonApiCall = async () => {
    let postObject = {
      searchFor: "leaveReason",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let leaveReasonArray = [];
      await data.map((leaveReason: any) => {
        let tempObj = {
          value: leaveReason.id,
          label: leaveReason.leavesReson,
        };
        leaveReasonArray.push(tempObj);
      });

      setLeaveReasonOptions(leaveReasonArray);
    }
  };

  const leaveTypeApiCall = async () => {
    let postObject = {};
    postObject = {
      searchFor: "leavetype1",
      searchValue: requestor.value,
      EmployeeId,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data !== undefined && data !== null && data.length > 0) {
      data.sort((a, b) => a.label.localeCompare(b.label));
      setLeaveTypeOptionsArr(data);

      if (state !== null) {
        const obj = data.find((i) => i.value === state.leaveType);
        setLeaveType(obj);
      } else {
        setLeaveType(data[0]);
      }
      // await getEmployeeLeave(data[0].value);
      // await onLoadLeaveBalance(data[0].value);
    }
  };

  const onLoadLeaveBalance = async (id) => {
    let postObject = {
      EmployeeId,
      LeaveTypeId: id,
    };

    const { data } = await APICall(
      EmployeeAvailableLeaveBalance,
      "POST",
      postObject
    );

    if (data !== null) {
      setLeaveBalance(data);
    }
  };

  const submitValidation = async () => {
   // debugger;
    await setFormErrors({});
    await getPendingLeaves();
    if (!fromDate) {
      setFormErrors((preState) => ({
        ...preState,
        ["fromDate_isEmpty"]: "From date can not be empty",
      }));
      formErrorObj["fromDate_isEmpty"] = "From date can not be empty";
    }

    if (!toDate) {
      setFormErrors((preState) => ({
        ...preState,
        ["toDate_isEmpty"]: "To date can not be empty",
      }));
      formErrorObj["toDate_isEmpty"] = "To date can not be empty";
    }

    const strippedFromDate = moment(fromDate).startOf("day");
    const strippedToDate = moment(toDate).startOf("day");

    const dayDifference = strippedToDate.diff(strippedFromDate, "days");

    if (dayDifference < 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["toDate_isEmpty"]: "To date can not be previous",
      }));
      formErrorObj["toDate_isEmpty"] = "To date can not be previous";
    }

    if (!leaveDays || leaveDays === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["leaveDays_isEmpty"]: "Leave days can not be empty",
      }));
      formErrorObj["leaveDays_isEmpty"] = "Leave days can not be empty";
    }

    if (!requestor || Object.keys(requestor).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["requestor_isEmpty"]: "Requestor can not be empty",
      }));
    }

    if (!approver || Object.keys(approver).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["approver_isEmpty"]: "Approver can not be empty",
      }));
    }

    if (!fromDateLeaveType || Object.keys(fromDateLeaveType).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["fromLeaveType_isEmpty"]: "Leave type can not be empty",
      }));
      formErrorObj["fromLeaveType_isEmpty"] = "Leave type can not be empty";
    }

    if (!toDateLeaveType || Object.keys(toDateLeaveType).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["toLeaveType_isEmpty"]: "Leave type can not be empty",
      }));
      formErrorObj["toLeaveType_isEmpty"] = "Leave type can not be empty";
    }

    if (!leaveType || Object.keys(leaveType).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["leaveType_isEmpty"]: "Leave type can not be empty",
      }));
      formErrorObj["leaveType_isEmpty"] = "Leave type can not be empty";
    }

    if (!leaveReason || Object.keys(leaveReason).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["leaveReason_isEmpty"]: "Leave reason can not be empty",
      }));
      formErrorObj["leaveReason_isEmpty"] = "Leave reason can not be empty";
    }
    if (location.state == null && (!leaveBalance || leaveBalance <= 0)) {
      //console.log('is locaiton empty >>>>> ',location.state == null)
      setFormErrors((preState) => ({
        ...preState,
        ["leaveBalance_isEmpty"]: "Leave balance not be empty",
      }));
      formErrorObj["leaveBalance_isEmpty"] = "Leave balance not be empty";
    }
    if (!FYIUsers || FYIUsers.length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["FYIUsers_isEmpty"]: "FYI Users can not be empty",
      }));
      formErrorObj["FYIUsers_isEmpty"] = "FYI Users can not be empty";
    }
    //Sanket 9-11
    if (remark === "") {
      setFormErrors((preState) => ({
        ...preState,
        ["remark_isEmpty"]: "Remarks can not be empty",
      }));
      formErrorObj["remark_isEmpty"] = "Remarks can not be empty";
    }
    //Deepak Gupta 05-03-25
    if (remark.trim().length < 5) {
      setFormErrors((preState) => ({
        ...preState,
        ["remark_isEmpty"]: "Remarks must be at least 5 characters long",
      }));
      formErrorObj["remark_isEmpty"] = "Remarks can not be empty";
    }
    //Yawar added on 25-07
    if (remark.length < 6) {
      setFormErrors((preState) => ({
        ...preState,
        ["remark_isEmpty"]: "Remarks is less than 5 characters.",
      }));
      formErrorObj["remark_isEmpty"] = "Remarks is less than 5 characters.";
    }
    let hasConflict = false;
    // **1-Month Gap Validation for Long Leave**
    if (leaveDays > configObj.LongLeaveMin) {
      pendingDates.forEach((pendingLeave) => {
        const pendingFromDate = moment(pendingLeave.fromDate).startOf("day");
        const pendingToDate = moment(pendingLeave.toDate).startOf("day");

        // Convert LongLeaveDiff to a number (default to 30 days if null)
        const longLeaveDiff = Number(configObj.LongLeaveDiff);

        // Add LongLeaveDiff days to the pending leave's toDate
        const limitDate = pendingToDate.clone().add(longLeaveDiff, "days");

        // Check if current leave's fromDate falls within LongLeaveDiff days
        if (strippedFromDate.isBefore(limitDate) && leaveType.value !== 3 &&
        leaveType.value !== 4 && leaveType.value !==2) {
          hasConflict = true;
        }
      });
      if(state == null || state.id == null || state.id == undefined)
      {
      if (!isLongLeaveAllowed ) {
        const message = `There must be a gap of at least ${configObj.LongLeaveDiff} days between two long leaves.`;
        notify(1, message);
        return false; // Stop further execution
      }
    }
    }

    return true;
  };

  const ReasonValidation = async () => {
    if (!leaveStatusOnEdit && state && state.role === "approver") {
      //sangam
      if (reason === "") {
        setFormErrors((preState) => ({
          ...preState,
          ["reason_isEmpty"]: "Reason can not be empty",
        }));
        formErrorObj["reason_isEmpty"] = "Reason can not be empty";
      }
      //sangam
      if (reason.length < 6) {
        setFormErrors((preState) => ({
          ...preState,
          ["reason_isEmpty"]: "Reason is less than 5 characters.",
        }));
        formErrorObj["reason_isEmpty"] = "Reason is less than 5 characters.";
      }
    }
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "fromDate") {     
      setFromDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: "To date can not be empty",
        }));
      }
    }
    if (apiFieldName === "toDate") {
      setToDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: "To date can not be empty",
        }));
      }
    }
    if (apiFieldName === "leaveDays") {
      setLeaveDays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["leaveDays_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["leaveDays_isEmpty"]: "Leave days can not be empty",
        }));
      }
    }
    if (apiFieldName === "remark") {
      setRemark(event.target.value);
      //Sanket 9-11
      setFormErrors((preState) => ({
        ...preState,
        ["remark_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["remark_isEmpty"]: "Remarks can not be empty",
        }));
        //Sanket 9-11
      }
    }

    if (apiFieldName === "reason") {
      //sangam
      setReason(event.target.value);
      setFormErrors((preState) => ({
        ...preState,
        ["reason_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["reason_isEmpty"]: "Reason can not be empty",
        }));
      }
    }
  };

  const getEmployeeLeave = async () => {
    // if (requestor != undefined && leaveType != undefined) {
    // let postObject = {
    //   EmployeeId: requestor.value,
    //   leaveType: leaveType.value,
    // };
    let postObject;
    if (state !== null) {
      postObject = {
        EmployeeId: state.requestorId,
        LeaveTypeId: state.leaveType,
      };
    } else {
      postObject = {
        EmployeeId: requestor.value,
        LeaveTypeId: leaveType.value,
      };
    }

    const { data } = await APICall(
      EmployeeAvailableLeaveBalance,
      "POST",
      postObject
    );

    if (data !== null) {
      setLeaveBalance(data);
    }
    //  }
  };

  const getApprover = async () => {
    if (state === null) {
      const { data } = await APICall(getEmployeeReportingManager, "POST", {
        EmployeeId: requestor.value,
      });
      if (data !== null && data !== 0) {
        approverId.current = data;
      } else if (data === 0) {
        setApprover({});
        notify(1, "No Reporting Manager is mapped for you, please contact HR");
      }
    }
  };

  const getPendingLeaves = async () => {
    if (state === null) {
      const res = await APICall(getPendingLeavesById, "POST", {
        requestorId: requestor.value,
      });
      if (res && res.status === 0 && res.data.length > 0) {
        let pendingDates = [];
        await res.data.map((ele) => {
          let tempObj = {
            fromDate: moment(ele.fromDate).format(moment.HTML5_FMT.DATE),
            toDate: moment(ele.toDate).format(moment.HTML5_FMT.DATE),
          };
          pendingDates.push(tempObj);
        });
        setPendingDates(pendingDates);
      }
    }
  };

  //UseEffects

  const submitFunc = async (action: any) => {
    //debugger;
    let submitObj: any = {};
    if (action === "submit") {
      const isValid = await submitValidation(); // Run validation first

      if (!isValid) {
        return; // Stop execution if validation fails
      }
      // HR section only start
      let HRleaveStatus = 3; // Default to pending
      const isHR = RoleIdArray.includes("4");
      const selectedRequestorId = requestor?.value;

      switch (true) {
        case isHR && selectedRequestorId === Number(EmployeeId):
          HRleaveStatus = 3; // Pending for HR's own request
          break;

        case isHR && selectedRequestorId !== Number(EmployeeId):
          HRleaveStatus = 1; // Approve for others
          break;

        default:
          HRleaveStatus = 3; // Default to pending
          break;
      }
      // HR Section End

      //HR Section for IsPlanned start
    
      

      //HR Section for IsPlanned end

      if (submitId !== 0 && state !== null) {
        let leaveStatus = 0;

        if (state.role === "self") {
          leaveStatus = 4;
        } else if (state.role === "approver") {
          if (leaveStatusOnEdit) {
            leaveStatus = 1;
          } else {
            leaveStatus = 2;
          }
        } else if (state.role === "manager") {
          leaveStatus = 4;
        } else {
          leaveStatus = 1;
        }

        // let leaveStatus =
        //   (state.role === "self" && leaveStatusOnEdit === true && 4) ||
        //   (state.role === "manager" && leaveStatusOnEdit === true ? 4 : 4) ||
        //   (state.role === "approver" && leaveStatusOnEdit === true ? 1 : 2);

        await ReasonValidation();
        let isEmpty = Object.values(formErrorObj).every(
          (f) => f === "" || f === null || f === undefined
        );
        if (isEmpty === true) {
          submitObj = {
            Id: submitId,
            RequestStatus: leaveStatus,
            leaveType: leaveType.value,
            EmployeeRole: state.role,
            FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
            ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
            Reason: reason === "" ? null : reason.trim(), // sangam
          };

          await submitApiCall(submitObj);
        }
      } else {
        submitObj = {
          RequestorId: requestor.value,
          ApproverId: approver.value,
          FYIUsersList: FYIUsers,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          FromDateLeaveType: fromDateLeaveType.value,
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
          ToDateLeaveType: toDateLeaveType.value,
          LeaveDays: leaveDays,
          leaveType: leaveType.value,
          ResonId: leaveReason.value,
          Remark: remark === "" ? null : remark.trim(),
          Reason: reason === "" ? null : reason.trim(), // sangam
          RequestStatus: HRleaveStatus,
          // RequestStatus: 3,
          IsActive: true,
          CreatedBy: Number(EmployeeId),
          CreatedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
          IsPlanned: isPlanned,
        };
        
        if (isHR && selectedRequestorId !== Number(EmployeeId)) {
          submitObj.HrApproveLeave = true;
        } else {
          submitObj.HrApproveLeave = false;
        }

        if (isHR && selectedRequestorId !== Number(EmployeeId)) {
          submitObj.IsPlanned = true;
        }

        //check if leaves for same day;
        let isSameDayLeavePending = false;

        //added by yawar on 26-07
        let isAlreadyPresentLeaveInBetween = false;
        let fDate;
        let tDate;
        //----------------------------

        if (pendingDates.length > 0) {
          pendingDates.forEach((element) => {
            if (
              element.fromDate === submitObj.FromDate ||
              element.toDate === submitObj.ToDate
            ) {
              isSameDayLeavePending = true;
            }

            //added by yawar on 26-07
            if (
              (element.fromDate > submitObj.FromDate &&
                submitObj.ToDate >= element.fromDate &&
                submitObj.ToDate < element.toDate) || //c5,7
              (element.toDate < submitObj.ToDate &&
                submitObj.FromDate > element.fromDate &&
                submitObj.FromDate <= element.toDate) || //c6,8
              (element.fromDate > submitObj.FromDate &&
                submitObj.ToDate > element.toDate) || //c9
              (element.fromDate < submitObj.FromDate &&
                submitObj.ToDate < element.toDate) //c10
            ) {
              isAlreadyPresentLeaveInBetween = true;
              fDate = element.fromDate;
              tDate = element.toDate;
            }
            //----------------------------
          });
        }
        if (leaveDays > leaveBalance) {
          notify(1, "Leave days cannot be greater than leave balance!");
        } else if (isSameDayLeavePending) {
          notify(1, "Leave present for same day!");
        }
        else if(!unplannedLeaveStatus && !isPlanned)
        {
          notify(1, "You have exceeded the limit for unplanned leaves. Please apply leave without pay instead of Unplanned if still you want to apply");
        }

        //added by yawar on 26-07
        else if (isAlreadyPresentLeaveInBetween) {
          notify(
            1,
            "Leave already present for days between " +
              fDate +
              " to " +
              tDate +
              " in the selected range!"
          );
        }
        //----------------------------
        else if (
          leaveDays > configObj.MaxLeaveCount &&
          leaveType.value !== 3 &&
          leaveType.value !== 4
        ) {
          notify(1, "Leaves can not be apply for more than 10 days!");
        } else if (
          leaveDays >= configObj.LongLeaveMin &&
          getDateDiff(toDate, lastApplied) < configObj.LongLeaveDiff &&
          lastLeaveDays >= configObj.LongLeaveMin
        ) {
          notify(1, "You can not apply for long leave within 30 days!");
        } else {
          await submitValidation();
          let isEmpty = Object.values(formErrorObj).every(
            (f) => f === "" || f === null || f === undefined
          );
          if (isEmpty === true) {
            await submitApiCall(submitObj);
          }
        }
      }
    }
    if (action === "reset") {
      resetFunc();
    }
  };

  // useEffect(() =>{
  //  leaveTypeApiCall();
  // },[requestor.value])

  const selectOnChange = async (event: any, apiFieldName: any) => {
    //debugger;
    if (apiFieldName === "requestor") {
      setRequestor(event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["requestor_isEmpty"]: undefined,
        })); // 🔥 Update requestorId in state
        getLeavesDashabordData(event.value);
      } else {
        setFormErrors((prev) => ({
          ...prev,
          requestor_isEmpty: "Requestor cannot be empty",
        }));
      }
    }

    if (apiFieldName === "approver") {
      setApprover(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["approver_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["approver_isEmpty"]: "Approver can not be empty",
        }));
      }
    }
    if (apiFieldName === "leaveType") {
      setLeaveType(event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["leaveType_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["leaveType_isEmpty"]: "Leave type can not be empty",
        }));
      }
    }
    if (apiFieldName === "fromLeaveType") {
      setFromDateLeaveType(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["fromLeaveType_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["fromLeaveType_isEmpty"]: "Leave type can not be empty",
        }));
      }
    }
    if (apiFieldName === "toLeaveType") {
      setToDateLeaveType(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["toLeaveType_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["toLeaveType_isEmpty"]: "Leave type can not be empty",
        }));
      }
    }
    if (apiFieldName === "leaveReason") {
      setLeaveReason(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["leaveReason_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["leaveReason_isEmpty"]: "Leave reason can not be empty",
        }));
      }
    }
    if (apiFieldName === "FYIUsers") {
      setFYIUsers(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["FYIUsers_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["FYIUsers_isEmpty"]: "FYI Users can not be empty",
        }));
      }
    }
  };

  useEffect(() => {
    (async () => {
      // console.log('holiday list 1==>', Number(EmployeeWorkPolicyId))
      const { data } = await APICall(getWorkPolicyHolidayList, "POST", {
        workPolicyId: Number(EmployeeWorkPolicyId),
      });
      if (data && data.length > 0) {
        // let temp = [...data];
        // temp = temp.filter((x) => x !== null);
        // setHolidayList(temp);

        //added by yawar on 26-07
        let holidayDates = [];
        let temp = [...data];
        temp = temp.filter((x) => x !== null);
        await temp.map((ele) => {
          holidayDates.push(moment(ele).format(moment.HTML5_FMT.DATE));
        });
        setHolidayList(holidayDates);
        //---------------------------
      }
    })();

    (async ()=>{
      const {data} = await APICall(getHolidayFromPolicyHoliday,"POST", { policyId: Number(EmployeeWorkPolicyId),});
      if(data && data.length > 0){
        let holidayDates = [];
        let temp = [...data];
        temp = temp.filter((x) => x !== null);
        await temp.map((ele) => {
          holidayDates.push(moment(ele).format(moment.HTML5_FMT.DATE));
        });
        setpolicyHolidays(holidayDates);
      }
    })();

    (async () => {
     // console.log('sat list 1=>', Number(EmployeeWorkPolicyId))
      const { data } = await APICall(getWorkPolicySaturdayList, "POST", {
        workPolicyId: Number(EmployeeWorkPolicyId),
      });
      if (data && data.length > 0) {
        //console.log('data1 ==>',data)
        let temp = [...data];
        temp = temp.filter((x) => x !== null);
        setWorkdayList(temp);
      }
    })();
  }, []);
  const getWorkdayList = async () => {
    let workPolicyId = 0;
    if (requestor.value === Number(EmployeeId)) {
      workPolicyId = Number(EmployeeWorkPolicyId);
    } else {
      workPolicyId = Number(requestor.workPolicyID);
    }
    //console.log('sat list 2==>',workPolicyId)
    const { data } = await APICall(getWorkPolicySaturdayList, "POST", {
      workPolicyId: Number(EmployeeWorkPolicyId),
    });
    if (data && data.length > 0) {
      let temp = [...data];
      temp = temp.filter((x) => x !== null);
      setWorkdayList(temp);
    } else {
      setWorkdayList([]);
    }
  };
  const getHolidayList = async () => {
    let workPolicyId = 0;
    if (requestor.value === Number(EmployeeId)) {
      workPolicyId = Number(EmployeeWorkPolicyId);
    } else {
      workPolicyId = Number(requestor.workPolicyID);
    }
    //console.log('holidat list 2==>', Number(workPolicyId))
    const { data } = await APICall(getWorkPolicyHolidayList, "POST", {
      //workPolicyId: Number(requestor.workPolicyID),

      //added by yawar on 26-07
      WorkPolicyId:  Number(EmployeeWorkPolicyId),
      //---------------------
    });
    if (data && data.length > 0) {
      // let temp = [...data];
      // temp = temp.filter((x) => x !== null);
      // setHolidayList(temp);

      //added by yawar on 26-07
      let holidayDates = [];
      let temp = [...data];
      temp = temp.filter((x) => x !== null);
      await temp.map((ele) => {
        holidayDates.push(moment(ele).format(moment.HTML5_FMT.DATE));
      });
      setHolidayList(holidayDates);
      //---------------------
    }
  };

  const getPolicyHolidayList = async () => {
    const {data} = await APICall(getHolidayFromPolicyHoliday,"POST", { policyId: Number(EmployeeWorkPolicyId),});
    if(data && data.length > 0){
      //console.log('data2 ===>',data)
      let holidayDates = [];
      let temp = [...data];
      temp = temp.filter((x) => x !== null);
      await temp.map((ele) => {
        holidayDates.push(moment(ele).format(moment.HTML5_FMT.DATE));
      });
      setpolicyHolidays(holidayDates);
    }
  }

  // const LastAppliedLeave = async () => {
  //   const { data } = await APICall(getLastAppliedLeave, "POST", {
  //     RequestorId: requestor.value,
  //   });
  //   if (data) {
  //     setLastApplied(data[0].fromDate);
  //     setLastLeaveDays(data[0].leaveDays);
  //   }
  // };
  // Fetch leave config on mount
  useEffect(() => {
    configObjApiCall();
  }, []);

  // Effect to update isLong AFTER both configObj and leaveDays are available
  useEffect(() => {
    if (configObj?.LongLeaveMin !== null && leaveDays !== null) {
      setIsLong(leaveDays > Number(configObj.LongLeaveMin)); // Ensure LongLeaveMin is a number
    }
  }, [leaveDays, configObj]); // Runs whenever leaveDays or configObj updates

  useEffect(() => {
    // debugger
    // Auto calculate leave days based on fromDate and toDate exclude sat & sun
    let FromDate = moment(fromDate);
    let ToDate = moment(toDate);

    let leaveDays;

    //function which exclude sat & sun
    function workday_count(start, end) {
      var first = start.clone().endOf("week"); // end of first week
      var last = end.clone().startOf("week"); // start of last week
      var days = (last.diff(first, "days") * 5) / 7; // this will always multiply of 7
      var wfirst = first.day() - start.day(); // check first week
      if (start.day() == 0) --wfirst; // -1 if start with sunday
      var wlast = end.day() - last.day(); // check last week
      if (end.day() == 6) --wlast; // -1 if end with saturday
      return wfirst + Math.floor(days) + wlast; // get the total
    }

    //function which include saturday
    function workday_count_sat(start, end) {
      var saturdays: string[];
      let diffEndMonth = false;
      if (start.month() !== end.month()) {
        diffEndMonth = true;
      }
      saturdays = getSaturdays(start.year(), start.month());

      var day = moment(start);
      var businessDays = 0;
      if (workdayList.length === 5) {
        while (day.isSameOrBefore(end, "day")) {
          if (day.day() == 1) businessDays++;
          if (day.day() == 2) businessDays++;
          if (day.day() == 3) businessDays++;
          if (day.day() == 4) businessDays++;
          if (day.day() == 5) businessDays++;
          if (day.day() == 6) businessDays++;
          day.add(1, "d");
        }
        return businessDays;
      } else {
        while (day.isSameOrBefore(end, "day")) {
          if (day.month() === end.month() && diffEndMonth === true) {
            saturdays = getSaturdays(end.year(), end.month());
          }
          if (day.day() == 1) businessDays++;
          if (day.day() == 2) businessDays++;
          if (day.day() == 3) businessDays++;
          if (day.day() == 4) businessDays++;
          if (day.day() == 5) businessDays++;
          if (day.day() == 6) {
            for (let i = 0; i < workdayList.length; i++) {
              if (Number(saturdays[workdayList[i]]) === day.date()) {
                businessDays++;
                break;
              }
            }
          }
          // if (day.day() == 6 && day.date() / 7 >= 0 && day.date() / 7 <= 1)
          //   businessDays++;

          // if (day.day() == 6 && day.date() / 7 >= 2 && day.date() / 7 <= 3)
          //   businessDays++;

          // if (day.day() == 6 && day.date() / 7 >= 4 && day.date() / 7 <= 5)
          //   businessDays++;
          day.add(1, "d");
        }
        return businessDays;
      }
    }
    function getSaturdays(year, month) {
      let day, date;
      let saturdays = [];
      day = 1;
      date = new Date(year, month, day);
      while (date.getMonth() === month) {
        if (date.getDay() === 6) {
          // Sun=0, Mon=1, Tue=2, etc.
          saturdays.push(new Date(year, month, day).getDate());
        }
        day += 1;
        date = new Date(year, month, day);
      }
      return saturdays;
    }
    if (workdayList.length === 0) {
      leaveDays = workday_count(FromDate, ToDate);
    } else {
      leaveDays = workday_count_sat(FromDate, ToDate);
    }

    if (!isNaN(leaveDays)) {
      //half day condition

      if (fromDateLeaveType.value === 2 || fromDateLeaveType.value === 3) {
        if (leaveDays === 0) {
          leaveDays = 0;
        } else {
          leaveDays = leaveDays - 0.5;
        }
      }
      if (
        (toDateLeaveType.value === 2 || toDateLeaveType.value === 3) &&
        !ToDate.isSame(FromDate, "day")
      ) {
        if (leaveDays === 0) {
          leaveDays = 0;
        } else {
          leaveDays = leaveDays - 0.5;
        }
      }
      if (
        fromDateLeaveType.value === 3 &&
        toDateLeaveType.value === 2 &&
        !ToDate.isSame(ToDate, "day")
      ) {
        leaveDays = leaveDays - 1;
      }

      setLeaveDays(leaveDays);

      setIsLong(leaveDays > configObj.LongLeaveMin);
    }

    let calculatedLeaveDays = workday_count(FromDate, ToDate);
    if (calculatedLeaveDays > 0) {
      if (fromDateLeaveType?.value === 2 || fromDateLeaveType?.value === 3) {
        calculatedLeaveDays -= 0.5;
      }
      if (toDateLeaveType?.value === 2 || toDateLeaveType?.value === 3) {
        calculatedLeaveDays -= 0.5;
      }
    }

    setLeaveDays(calculatedLeaveDays);

    // find if holiday is there in between from and to date
    if (
      FromDate !== null &&
      ToDate !== null &&
      //holidayList.length > 0 &&
      //policyHolidays.length > 0 &&
      leaveDays > 0
    ) {
      let totalCount = 0;

      //added by yawar on 26-07
      let tempFrom = moment(FromDate).format(moment.HTML5_FMT.DATE);
      let tempTo = moment(ToDate).format(moment.HTML5_FMT.DATE);
      //-----------------------

      // holidayList.forEach((element) => {
      //   // let range = moment(element).isBetween(
      //   //   FromDate,
      //   //   ToDate,
      //   //   undefined,
      //   //   "[]"
      //   // );

      //   //added by yawar on 26-07
      //   let range = moment(element).isBetween(
      //     tempFrom,
      //     tempTo,
      //     undefined,
      //     "[]"
      //   );
      //   //-----------------------

      //   if (range) {
      //     totalCount++;
      //   }
      // });

      policyHolidays.forEach((ele) => {
        let range = moment(ele).isBetween(
          tempFrom, tempTo, undefined, "[]"
        );

        if(range){
          totalCount++;
        }
      });

      leaveDays = leaveDays - totalCount;
      setLeaveDays(leaveDays);

      const isHR = RoleIdArray.includes("4");
      const selectedRequestorId = requestor?.value;

      if(isHR && selectedRequestorId !== Number(EmployeeId))
        {
          setIsPlanned(true);
        }
      else if (leaveDays <= configObj.ShortLeaveMax && !location.state) {
      // console.log('checkl',configObj)
        setIsPlanned(
          getDateDiff(
            FromDate,
            moment(new Date()).format(moment.HTML5_FMT.DATE)
          ) < Number(configObj.ShortLeaveCond)
            ? false
            : true
        );
      } else if (
        leaveDays >= configObj.LongLeaveMin &&
        leaveDays <= configObj.LongLeaveMax && 
        !location.state
      ) {
       // console.log('inside ')
        setIsPlanned(
          getDateDiff(
            FromDate,
            moment(new Date()).format(moment.HTML5_FMT.DATE)
          ) < Number(configObj.LongLeaveCond)
            ? false
            : true
        );
      }
    }
  }, [
    fromDate,
    toDate,
    fromDateLeaveType,
    toDateLeaveType,
    currentrequestor,
    leaveType,
  ]);

  const getDateDiff = (fDate: any, sDate: any) => {
    var date1 = new Date(fDate);
    var date2 = new Date(sDate);
    var Difference_In_Time = date1.getTime() - date2.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
   // return Difference_In_Days;
    var roundedDifference = Math.round(Difference_In_Days); 
   // console.log('date diff', roundedDifference);
    return roundedDifference;
  };
  const configObjApiCall = () => {
    (async () => {
      let tempObj = {
        MaxLeaveCount: null,
        LongLeaveDiff: null,
        ShortLeaveCond: null,
        LongLeaveCond: null,
        ShortLeaveMin: null,
        ShortLeaveMax: null,
        LongLeaveMin: null,
        LongLeaveMax: null,
      };
      const { data } = await APICall(getLeaveConfigData, "POST");
      data.map((el: any) => {
        if (el.configKey === "ShortLeaveCond") {
          tempObj.ShortLeaveCond = el.configValue;
        } else if (el.configKey === "LongLeaveCond") {
          tempObj.LongLeaveCond = el.configValue;
        } else if (el.configKey === "MaxLeaveCount") {
          tempObj.MaxLeaveCount = el.configValue;
        } else if (el.configKey === "LongLeaveDiff") {
          tempObj.LongLeaveDiff = el.configValue;
        } else if (el.configKey === "ShortLeaveMin") {
          tempObj.ShortLeaveMin = el.configValue;
        } else if (el.configKey === "ShortLeaveMax") {
          tempObj.ShortLeaveMax = el.configValue;
        } else if (el.configKey === "LongLeaveMin") {
          tempObj.LongLeaveMin = el.configValue;
        } else if (el.configKey === "LongLeaveMax") {
          tempObj.LongLeaveMax = el.configValue;
        }
      });
      setConfigObj(tempObj);
    })();
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "fromDate",
      label: "From Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value) => {
          // For display
          return value ? moment(value).format("DD-MM-YYYY") : ""; // Handle null/undefined
        },
      },
    },
    {
      name: "toDate",
      label: "To Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value) => {
          // For display
          return value ? moment(value).format("DD-MM-YYYY") : ""; // Handle null/undefined
        },
      },
    },
    {
      name: "leaveDays",
      label: "leave Days",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "leaveName",
      label: "Leave Type",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "leavesReson",
      label: "Leaves Reson",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "leaveRequestName",
      label: "Leave status",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
  ];

  const options = {
    selectableRows: "none",
    count: count,
    pageSize: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    // customSearchRender: debounceSearchRender(500),
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const getLeavesDashabordData = async (employeeId?: number) => {
    //debugger;
    showLoader();
    let requestParams = {
      Start: start,
      PageSize: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      EmployeeId: employeeId ? employeeId : currentrequestor.value, //Login Id
    };
    // console.log('obj=>',requestParams)
    const { data } = await APICall(
      GetEmployeeLeavesData,
      "POST",
      requestParams
    );

    setEmployeeLeaveData(data);
    setCount(data[0]?.count);
    hideLoader();
  };
    //console.log('state==>',state)
  return (
    <>
      <Heading title={"Request Leave / Report Absence"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label className="d-block">
                From Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="From date"
                  value={fromDate}
                  disabled={state !== null ? true : false}
                  onChange={(e) => handleTextEvent(e, "fromDate") }
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  minDate={
                    state === null && requestor.value === Number(EmployeeId)
                      ? new Date()
                      : undefined
                  }
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>{formErrors["fromDate_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                From Date Leave Type <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                disabled={state !== null ? true : false}
                options={leaveTypeOptions}
                placeholder="Select"
                isDisabled={state !== null ? true : false}
                value={fromDateLeaveType}
                onChange={(event) => selectOnChange(event, "fromLeaveType")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>
                {formErrors["fromLeaveType_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label className="d-block">
                To Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="To date"
                  disabled={state !== null ? true : false}
                  value={toDate}
                  onChange={(e) => handleTextEvent(e, "toDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  minDate={fromDate}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport",
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>{formErrors["toDate_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                To Date Leave Type <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                disabled={state !== null ? true : false}
                options={leaveTypeOptions}
                placeholder="Select"
                isDisabled={state !== null ? true : false}
                value={toDateLeaveType}
                onChange={(event) => selectOnChange(event, "toLeaveType")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
                //filterOption={(option) => option.value !== 3}
              />
              <p style={{ color: "red" }}>
                {formErrors["toLeaveType_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Leave Reason <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={leaveReasonOptions}
                placeholder="Select"
                isDisabled={state !== null ? true : false}
                value={leaveReason}
                onChange={(event) => selectOnChange(event, "leaveReason")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>
                {formErrors["leaveReason_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Leave Type <sup>*</sup>
              </label>
              <SelectForm
                options={leaveTypeOptionsArr}
                setFilterObj
                placeholder="Select"
                isDisabled={state !== null ? true : false}
                value={leaveType}
                onChange={(event) => selectOnChange(event, "leaveType")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["leaveType_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Leave Balance <sup>*</sup>
              </label>
              <InputForm
                placeholder={"Leave days"}
                isDisabled={true}
                textArea={false}
                value={leaveBalance}
                onChange={(e) => handleTextEvent(e, "leaveDays")}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <p style={{ color: "red" }}>
                {formErrors["leaveBalance_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Leave days <sup>*</sup>
              </label>
              <InputForm
                placeholder={"Leave days"}
                isDisabled={true}
                textArea={false}
                value={leaveDays}
                onChange={(e) => handleTextEvent(e, "leaveDays")}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <p style={{ color: "red" }}>{formErrors["leaveDays_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Requestor <sup>*</sup>
              </label>
              <SelectForm
                options={approverOptions}
                placeholder="Select"
                isDisabled={
                  state !== null
                    ? true
                    : false || canChangeRequestor
                    ? false
                    : true
                }
                value={requestor}
                onChange={(event) => selectOnChange(event, "requestor")}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["requestor_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Approver <sup>*</sup>
              </label>
              <SelectForm
                options={approverOptions}
                placeholder="Select"
                isDisabled={true}
                value={approver}
                onChange={(event) => selectOnChange(event, "approver")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["approver_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                FYI Users <sup>*</sup>
              </label>
              <SelectForm
                options={approverOptions}
                placeholder="Select"
                isDisabled={state !== null ? true : false}
                value={FYIUsers}
                onChange={(event) => selectOnChange(event, "FYIUsers")}
                isMulti={true}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["FYIUsers_isEmpty"]}</p>
            </div>
          </div>

          {state !== null && state.role !== "viewer" && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  {/* {state.role !== "self" ? "Approve Leave" : "Cancel Leave"} */}
                  {state.role === "manager"
                    ? "Cancel Leave"
                    : state.role === "approver"
                    ? "Approve Leave"
                    : state.role === "self"
                    ? "Cancel Leave"
                    : "Approve Leave"}
                    <sup>*</sup>
                  </label>
                  <br />

                  <label
                    htmlFor="custom-switch"
                    style={{ float: "left" }}
                    className="mr-2"
                  >
                    No
                  </label>
                  <Form style={{ float: "left" }}>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label=""
                      disabled={state && state.role === "viewer" ? true :  (leavestatusId == 1 && state.role === "self") || (leavestatusId == 1 && state.role === "manager")? false : (leavestatusId == 1 ) ? true : false}
                      onChange={(e) => setLeaveStatusOnEdit(e.target.checked)}
                      checked={leaveStatusOnEdit}
                    />
                  </Form>
                  <label
                    htmlFor="custom-switch"
                    style={{ float: "left" }}
                    className="ml-2"
                  >
                    Yes
                  </label>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Remark<sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"Remark"}
                    isDisabled={state !== null ? true : false}
                    textArea={true}
                    value={remark}
                    rows={4}
                    onChange={(e) => handleTextEvent(e, "remark")}
                  />
                  <p style={{ color: "red" }}>{formErrors["remark_isEmpty"]}</p>
                </div>
              </div>

              {state !== null && (
                <div className="col-lg-4 col-md-4 col-sm-6">
                  {" "}
                  {/*sangam */}
                  <div className="form-group">
                    <label>
                      Reason<sup>*</sup>
                    </label>
                    <InputForm
                      placeholder={"Reason for not approving leave"}
                      isDisabled={leaveStatusOnEdit == false ? false : true}
                      textArea={true}
                      value={reason}
                      rows={4}
                      onChange={(e) => handleTextEvent(e, "reason")}
                    />
                    {!leaveStatusOnEdit && (
                      <p style={{ color: "red" }}>
                        {formErrors["reason_isEmpty"]}
                      </p>
                    )}
                  </div>
                </div>
              )}
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>IsPlanned</label>
                  <br />

                  <label
                    htmlFor="custom-switch"
                    style={{ float: "left" }}
                    className="mr-2"
                  >
                    Unplanned
                  </label>
                  <Form style={{ float: "left" }}>
                    <Form.Check
                      type="switch"
                      id="isPlanned-switch"
                      label=""
                      disabled={true}
                      onChange={(e) => setIsPlanned(e.target.checked)}
                      checked={isPlanned}
                    />
                  </Form>
                  <label
                    htmlFor="isPlanned-switch"
                    style={{ float: "left" }}
                    className="ml-2"
                  >
                    Planned
                  </label>
                </div>
              </div>

              {/* Leave type */}
              {state?.role === "approver" && (
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Leave</label>
                    <br />

                    <label
                      htmlFor="custom-switch"
                      style={{ float: "left" }}
                      className="mr-2"
                    >
                      Short Leave
                    </label>

                    <Form style={{ float: "left" }}>
                      <Form.Check
                        type="switch"
                        id="isLong-switch"
                        label=""
                        disabled={true} // Enable toggle
                        onChange={(e) => setIsLong(e.target.checked)}
                        checked={isLong}
                      />
                    </Form>

                    <label
                      htmlFor="isLong-switch"
                      style={{ float: "left" }}
                      className="ml-2"
                    >
                      Long Leave
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="row">
              <div className="col-lg-12">
                <div className="d-flex justify-content-between">
                  <div>
                    <button 
                    onClick={() => 
                      navigate(`${env}/master/leaveRequest`,{state:state})
                       //</div></div> navigate('/master/leaveRequest',{state:state})
                      } 
                      className="btn btn-reset">
                      <i className="fa fa-chevron-left"></i>
                    </button>
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      onClick={() => submitFunc("reset")}
                      className="btn btn-reset"
                      disabled={state !== null ? true : false}
                    >
                      Reset
                    </button>

                    <button
                      onClick={() => submitFunc("submit")}
                      className="btn btn-submit"
                      disabled={
                        approverId.current === 0
                          ? true
                          : false ||
                            (state !== null &&
                              state.role === "self" &&
                              leaveStatusOnEdit === false)
                          ? true
                          : false || (state !== null && state.role === "viewer") 
                          ? true
                          : false
                      }
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>


          {/* <div className="d-flex justify-content-end gap-2">
                  <div>
                    <button onClick={() => navigate(-1)} className="btn btn-reset">
                      <i className="fa fa-chevron-left"></i>
                    </button>
                  </div>

            <button
              onClick={() => submitFunc("reset")}
              className="btn btn-reset ml-1"
              disabled={state !== null ? true : false}
            >
              Reset
            </button>
            <button
              //style={{ background: "#96c61c" }}
              onClick={() => submitFunc("submit")}
              className="btn btn-submit"
              disabled={
                approverId.current === 0
                  ? true
                  : false ||
                    (state !== null &&
                      state.role === "self" &&
                      leaveStatusOnEdit === false)
                  ? true
                  : false || (state !== null && state.role === "viewer") 
                  ? true
                  : false
              }
            >
              Submit
            </button>
            {/* <button onClick={() => navigate(-1)} className="btn btn-secondary">
              Back
            </button> 
          </div> */}

          {state?.role === "approver" && (
             <div className="col-lg-12 mt-3">
                <DynamicGrid 
                  options={options}
                  data={employeeLeaveData}
                  columns={gridColumns}
                />
            </div>
          )}
        </div>
    </>
  );
};

export default LeaveRequestMasterEdit;
